import axios from "axios";
import API_BASE_URL from "../config/env";
import { handleApiError } from "../utils/errorHandler";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 45000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor in apiClient.js
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
      return Promise.reject(error); // Pass original error
    }

    // This is the key change:
    // We attach the clean message to the existing error object
    // instead of replacing the whole object.
    error.cleanMessage = handleApiError(error);

    return Promise.reject(error);
  },
);

export default apiClient;
